// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_CheckoutResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SetupFee_CheckoutResponseDados {
charge_id: number
checkout_url: string
provider_charge_id: string
status: string
amount_cents: number
currency: string
installments: number
}

export type SetupFee_CheckoutResponse = ApiResponse<SetupFee_CheckoutResponseDados>;

registerResponseContract('SetupFee_CheckoutResponse', {
  charge_id:          { type: 'number',  required: true },
  checkout_url:       { type: 'string',  required: true },
  provider_charge_id: { type: 'string',  required: true },
  status:             { type: 'string',  required: true },
  amount_cents:       { type: 'number',  required: true },
  currency:           { type: 'string',  required: true },
  installments:       { type: 'number',  required: true },
})
